export default "__VITE_ASSET__DLzLpAf4__"